/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technologies_StaleInputs */

const en_us2_technologies_stale = /** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile is being refreshed.`)
};

const es_es2_technologies_stale = /** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este perfil se está actualizando.`)
};

const ru_technologies_stale = /** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот профиль обновляется.`)
};

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const id_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const ms_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const da_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const de_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const es_mx2_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const fil_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const fr_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const it_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const hu_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const nl_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const no_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const pl_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const pt_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const pt_br2_technologies_stale = pt_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const ro_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const fi_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const sv_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const vi_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const tr_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const cs_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const bg_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const uk_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const ar_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const hi_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const th_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const ja_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const zh_cn2_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const zh_hant1_technologies_stale = en_us2_technologies_stale;

/** @type {(inputs: Technologies_StaleInputs) => LocalizedString} */
const ko_technologies_stale = en_us2_technologies_stale;

/**
* | output |
* | --- |
* | "This profile is being refreshed." |
*
* @param {Technologies_StaleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_stale = /** @type {((inputs?: Technologies_StaleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_StaleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_stale(inputs)
	if (locale === "ms") return ms_technologies_stale(inputs)
	if (locale === "da") return da_technologies_stale(inputs)
	if (locale === "de") return de_technologies_stale(inputs)
	if (locale === "en-US") return en_us2_technologies_stale(inputs)
	if (locale === "es-ES") return es_es2_technologies_stale(inputs)
	if (locale === "es-MX") return es_mx2_technologies_stale(inputs)
	if (locale === "fil") return fil_technologies_stale(inputs)
	if (locale === "fr") return fr_technologies_stale(inputs)
	if (locale === "it") return it_technologies_stale(inputs)
	if (locale === "hu") return hu_technologies_stale(inputs)
	if (locale === "nl") return nl_technologies_stale(inputs)
	if (locale === "no") return no_technologies_stale(inputs)
	if (locale === "pl") return pl_technologies_stale(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_stale(inputs)
	if (locale === "pt") return pt_technologies_stale(inputs)
	if (locale === "ro") return ro_technologies_stale(inputs)
	if (locale === "fi") return fi_technologies_stale(inputs)
	if (locale === "sv") return sv_technologies_stale(inputs)
	if (locale === "vi") return vi_technologies_stale(inputs)
	if (locale === "tr") return tr_technologies_stale(inputs)
	if (locale === "cs") return cs_technologies_stale(inputs)
	if (locale === "bg") return bg_technologies_stale(inputs)
	if (locale === "ru") return ru_technologies_stale(inputs)
	if (locale === "uk") return uk_technologies_stale(inputs)
	if (locale === "ar") return ar_technologies_stale(inputs)
	if (locale === "hi") return hi_technologies_stale(inputs)
	if (locale === "th") return th_technologies_stale(inputs)
	if (locale === "ja") return ja_technologies_stale(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_stale(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_stale(inputs)
	return ko_technologies_stale(inputs)
});
export { technologies_stale as "technologies.stale" }